<!--
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*
-->

<app-dialog-banner [text]="config.getTitle()" [dialogRef]="dialogRef"></app-dialog-banner>
<!--  Only limit max height so default height for smaller forms is as much as required only -->
<mat-dialog-content [style.width.px]="width" [style.max-height.px]="height">
  <app-form [config]="config" [dialogRef]="$any(dialogRef)"></app-form>
</mat-dialog-content>
